import { __ } from '@wordpress/i18n';
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

import { useEffect } from '@wordpress/element';
import Style from './Style.jsx';
import blockJson from './block.json';

export default function Edit( props ) {
	const { attributes, clientId, setAttributes } = props;

	const { blockId } = attributes;

	useEffect( () => {
		setAttributes( { blockId: clientId } );
	}, [ clientId ] );

	const blockProps = useBlockProps( {
		className: `alpha-hero-block alpha-hero-block-${ blockId }`,
	} );

	return (
		<div { ...blockProps }>
			<Style
				attributes={ attributes }
				blockId={ blockId }
				setAttributes={ setAttributes }
			/>
			<window.InspectorGenerator props={ props } blockJson={ blockJson } />
			<div className={ 'columns-wrapper' }>
				<InnerBlocks
					allowedBlocks={ [ 'alpha-blocks/columns' ] }
					template={ [
						[
							'alpha-blocks/columns',
							{
								blockId: 'c29d1fa1-a00e-4f82-8bf8-c82633085e98',
								initialOpen: [ 'general' ],
								columnsLayout: '2',
								columnGap: {
									desktop: {
										val: 0,
										unit: 'px',
									},
								},
								verticalAlignment: 'space-between',
								flexDirection: 'horizontal',
								justifyContent: 'space-around',
								flexWrap: 'nowrap',
								minHeight: {
									desktop: {
										val: '50',
										unit: 'px',
									},
								},
								containerBackground: {
									enableBackground: true,
									backgroundType: 'color-gradient',
									backgroundColorGradient: {
										type: 'color',
										color: '#ffffff',
									},
									backgroundImage: {
										url: '',
									},
									backgroundSize: 'cover',
									backgroundPosition: 'center center',
									backgroundRepeat: 'no-repeat',
									backgroundAttachment: 'scroll',
								},
								margin: {},
								padding: {},
								containerBorder: {},
							},
							[
								[
									'alpha-blocks/column',
									{
										blockId:
											'1fa22e46-9cd2-492c-ade6-f268ca516d09',
										initialOpen: [ 'general' ],
										columnWidth: {
											desktop: {
												unit: '%',
												val: 50,
											},
										},
										columnBackground: {},
										padding: {},
										border: {},
										alignItems: 'center',
										justifyContent: 'center',
										flexDirection: 'column',
										flexWrap: 'nowrap',
										gap: {
											desktop: {
												val: 8,
												unit: 'px',
											},
										},
										maxHeight: {
											desktop: {
												unit: 'px',
											},
										},
										overflow: 'visible',
									},
									[
										[
											'alpha-blocks/heading',
											{
												content:
													'Your Advanced Attractive Heading',
												initialOpen: [ 'general' ],
												level: 2,
												containerBorder: {
													width: 0,
													style: 'solid',
													color: '#000000',
												},
												containerBorderRadius: {
													topLeft: 0,
													topRight: 0,
													bottomRight: 0,
													bottomLeft: 0,
													desktop: {
														unit: 'px',
													},
												},
												margin: {
													top: 0,
													right: 0,
													bottom: 0,
													left: 0,
													desktop: {
														unit: 'px',
													},
												},
												padding: {
													top: 0,
													right: 0,
													bottom: 0,
													left: 0,
													desktop: {
														unit: 'px',
													},
												},
												minHeight: {
													desktop: {
														val: 0,
														unit: 'px',
													},
													tablet: {
														val: 0,
														unit: 'px',
													},
													mobile: {
														val: 0,
														unit: 'px',
													},
												},
												alignment: 'center',
												verticalAlignment: 'center',
												typography: {
													fontFamily: 'DM Sans',
													fontSize: {
														desktop: {
															val: 34,
															unit: 'px',
														},
													},
													fontWeight: '700',
													fontStyle: false,
													fontTransform: false,
													fontDecoration: 'default',
													fontLineHeight: {
														desktop: {
															unit: 'px',
															val: 27,
														},
													},
													fontLetterSpacing: {
														desktop: {
															unit: 'px',
															val: 2,
														},
													},
												},
												enableBackground: false,
												backgroundType:
													'color-gradient',
												backgroundColor: {
													type: 'color',
													color: '#ffffff',
												},
												backgroundImage: [],
												enableTopLine: false,
												topLineColor: {
													type: 'color',
													color: '#ffffff',
												},
												topLineWidth: {
													desktop: {
														val: 100,
														unit: 'px',
													},
													tablet: {
														val: 100,
														unit: 'px',
													},
													mobile: {
														val: 100,
														unit: 'px',
													},
												},
												topLineHeight: {
													desktop: {
														val: 2,
														unit: 'px',
													},
													tablet: {
														val: 2,
														unit: 'px',
													},
													mobile: {
														val: 2,
														unit: 'px',
													},
												},
												topLineMargin: {
													top: 0,
													right: 0,
													bottom: 0,
													left: 0,
												},
												topLineAlignment: 'center',
												enableBottomLine: false,
												bottomLineColor: {
													type: 'color',
													color: '#ffffff',
												},
												bottomLineWidth: {
													desktop: {
														val: 100,
														unit: 'px',
													},
													tablet: {
														val: 100,
														unit: 'px',
													},
													mobile: {
														val: 100,
														unit: 'px',
													},
												},
												bottomLineHeight: {
													desktop: {
														val: 2,
														unit: 'px',
													},
													tablet: {
														val: 2,
														unit: 'px',
													},
													mobile: {
														val: 2,
														unit: 'px',
													},
												},
												bottomLineMargin: {
													top: 0,
													right: 0,
													bottom: 0,
													left: 0,
												},
												bottomLineAlignment: 'center',
												enableSubHeading: false,
												subHeadingContent:
													'Your Attractive Sub-heading',
												subHeadingTag: 'span',
												subHeadingPosition: 'above',
												subHeadingTypography: {
													fontFamily: 'default',
													fontSize: {
														desktop: {
															val: 16,
															unit: 'px',
														},
														tablet: {
															val: 16,
															unit: 'px',
														},
														mobile: {
															val: 16,
															unit: 'px',
														},
													},
													fontWeight: false,
													fontStyle: false,
													fontTransform: false,
													fontDecoration: 'default',
													fontLineHeight: {
														desktop: {
															unit: 'px',
															val: 24,
														},
														tablet: {
															unit: 'px',
															val: 24,
														},
														mobile: {
															unit: 'px',
															val: 24,
														},
													},
													fontLetterSpacing: {
														desktop: {
															unit: 'px',
															val: 0,
														},
														tablet: {
															unit: 'px',
															val: 0,
														},
														mobile: {
															unit: 'px',
															val: 0,
														},
													},
												},
												subHeadingMargin: {
													top: 0,
													right: 0,
													bottom: 0,
													left: 0,
												},
												subHeadingColor: {
													type: 'color',
													gradient:
														'linear-gradient(135deg,rgba(6,147,227,1) 0%,rgb(155,81,224) 100%)',
													color: '',
												},
												textColor: {
													type: 'color',
													gradient:
														'linear-gradient(135deg,rgba(6,147,227,1) 0%,rgb(155,81,224) 100%)',
													color: '#382875',
												},
												zIndex: {
													desktop: {
														val: 1,
													},
													tablet: {
														val: 1,
													},
													mobile: {
														val: 1,
													},
												},
												enableHover: false,
												hoverTextColor: {
													type: 'color',
													color: '',
												},
												hoverBackgroundColor: {
													type: 'color',
													color: '',
												},
												hoverBorder: {
													top: {
														color: '#000',
														style: 'solid',
														width: '1px',
													},
													right: {
														color: '#000',
														style: 'solid',
														width: '1px',
													},
													bottom: {
														color: '#000',
														style: 'solid',
														width: '1px',
													},
													left: {
														color: '#000',
														style: 'solid',
														width: '1px',
													},
												},
												hoverBorderRadius: {
													topLeft: 0,
													topRight: 0,
													bottomRight: 0,
													bottomLeft: 0,
												},
												hideOnDesktop: false,
												hideOnTablet: false,
												hideOnMobile: false,
											},
										],
										[
											'alpha-blocks/alpha-text',
											{
												initialOpen: [ 'general' ],
												content:
													'Please enter your text or message here. Please enter your text or message herePlease enter your text or message herePlease enter your text or message here. Please enter your text or message herePlease enter your text or message herePlease enter your text or message here. Please enter your text or message herePlease enter your text or message here',
												level: 'p',
												align: 'center',
												color: {},
												typography: {
													fontFamily: 'Poppins',
													fontSize: {
														desktop: {
															val: 14,
															unit: 'px',
														},
													},
													fontWeight: '400',
													fontStyle: false,
													fontTransform: false,
													fontDecoration: 'default',
													fontLineHeight: {
														desktop: {
															unit: 'px',
															val: 20,
														},
													},
													fontLetterSpacing: {
														desktop: {
															unit: 'px',
															val: 0,
														},
													},
												},
												backgroundColor: {},
												containerBorder: {
													width: '0px',
													style: 'solid',
													color: '#000000',
												},
												margin: {},
												padding: {},
											},
										],
										[
											'alpha-blocks/button',
											{
												blockID:
													'alpha-button-4ce74a48-acc2-4c5c-9315-8f9840e29fc2',
												buttonText: 'Watch the Details',
												buttonTextColor: {
													color: '#111111',
													type: 'color',
												},
												buttonLinkUrl:
													'https://plus.unsplash.com/premium_photo-1683865776032-07bf70b0add1?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
												buttonLinkOpenInNewTab: true,
												buttonLinkRel: '',
												buttonLinkTitle: '',
												buttonAnchorId: '',
												textAlignment: 'space-evenly',
												typography: {
													fontFamily: 'ABeeZee',
													fontSize: {
														desktop: {
															unit: 'px',
														},
													},
													fontStyle: 'normal',
													fontDecoration: 'None',
													fontLineHeight: {
														desktop: {
															unit: 'px',
														},
													},
													fontLetterSpacing: {
														desktop: {
															unit: 'px',
														},
													},
												},
												maxContentWidth: {
													desktop: {
														val: 416,
														unit: '%',
													},
													tablet: {
														val: '100',
														unit: '%',
													},
													mobile: {
														val: '100',
														unit: '%',
													},
												},
												minHeight: {
													desktop: {
														val: '',
														unit: 'px',
													},
													tablet: {
														val: '',
														unit: 'px',
													},
													mobile: {
														val: '',
														unit: 'px',
													},
												},
												margin: {
													desktop: {
														unit: 'px',
													},
												},
												padding: {
													desktop: {
														sideTop: '9',
														sideRight: '26',
														sideBottom: '9',
														sideLeft: '26',
														unit: 'px',
													},
												},
												border: {
													width: '1px',
													style: 'solid',
													color: 'rgba(0,0,0,1)',
												},
												borderRadius: {
													desktop: {
														sideTop: '11',
														sideRight: '11',
														sideBottom: '11',
														sideLeft: '11',
														unit: 'px',
													},
												},
												containerBackground: {},
												containerShadow: {},
												buttonHoverTextColor: {},
												buttonHoverBackgroundColor: {},
												buttonHoverBorder: {},
											},
										],
									],
								],
								[
									'alpha-blocks/column',
									{
										blockId:
											'a1e22420-1ba4-4d9d-9e36-c1f8a1d3dbdb',
										initialOpen: [ 'general' ],
										columnWidth: {
											desktop: {
												unit: '%',
												val: 50,
											},
										},
										columnBackground: {},
										padding: {},
										border: {},
										alignItems: 'flex-start',
										justifyContent: 'flex-start',
										flexDirection: 'column',
										flexWrap: 'nowrap',
										gap: {
											desktop: {
												val: '0',
												unit: 'px',
											},
										},
										maxHeight: {
											desktop: {
												unit: 'px',
											},
										},
										overflow: 'visible',
									},
									[
										[
											'alpha-blocks/image',
											{
												containerBorder: {
													width: 0,
													style: 'solid',
													color: '#000000',
												},
												containerBorderRadius: {
													desktop: {
														sideTop: '2',
														sideRight: '2',
														sideBottom: '2',
														sideLeft: '2',
														unit: 'px',
													},
												},
												margin: {
													desktop: {
														sideTop: '2',
														sideRight: '2',
														sideBottom: '2',
														sideLeft: '2',
														unit: 'px',
													},
												},
												padding: {
													desktop: {
														sideTop: '2',
														sideRight: '2',
														sideBottom: '2',
														sideLeft: '2',
														unit: 'px',
													},
												},
												mediaImage: {
													id: null,
													url: 'https://images.pexels.com/photos/906150/pexels-photo-906150.jpeg',
													alt: '',
												},
												caption: '',
												disableLazyLoading: false,
												horizontalAlignment: 'center',
												verticalAlignment: 'center',
												enableOverlay: false,
												enableText: false,
												overlayBackgroundColor: {
													type: 'color',
													gradient:
														'linear-gradient(135deg,rgba(6,147,227,1) 0%,rgb(155,81,224) 100%)',
													color: '#fff',
												},
												overlayTextColor: {
													type: 'color',
													gradient:
														'linear-gradient(135deg,rgba(6,147,227,1) 0%,rgb(155,81,224) 100%)',
													color: '#fff',
												},
												overlayText: '',
												overlayTypography: {
													fontFamily: 'default',
													fontSize: {
														desktop: {
															val: 16,
															unit: 'px',
														},
													},
													fontWeight: false,
													fontStyle: false,
													fontTransform: false,
													fontDecoration: 'default',
													fontLineHeight: {
														desktop: {
															unit: 'px',
															val: 24,
														},
													},
													fontLetterSpacing: {
														desktop: {
															unit: 'px',
															val: 0,
														},
													},
												},
												overlayOpacity: {
													desktop: {
														val: 100,
														unit: '%',
													},
												},
												imageWidth: {
													desktop: {
														val: 100,
														unit: '%',
													},
													tablet: {
														val: 100,
														unit: '%',
													},
													mobile: {
														val: 100,
														unit: '%',
													},
												},
												imageHeight: {
													desktop: {
														val: 100,
														unit: '%',
													},
													tablet: {
														val: 100,
														unit: '%',
													},
													mobile: {
														val: 100,
														unit: '%',
													},
												},
												altText: '',
												title: '',
												imageObjectFit: 'cover',
												imageMaskShape: '',
												enableImageCaption: false,
												captionAlignment: 'left',
												typography: {
													fontFamily: 'default',
													fontSize: {
														desktop: {
															val: 16,
															unit: 'px',
														},
													},
													fontWeight: false,
													fontStyle: false,
													fontTransform: false,
													fontDecoration: 'default',
													fontLineHeight: {
														desktop: {
															unit: 'px',
															val: 24,
														},
													},
													fontLetterSpacing: {
														desktop: {
															unit: 'px',
															val: 0,
														},
													},
												},
												hoverBorder: {
													width: 0,
													style: 'solid',
													color: '#000000',
												},
												imageBoxShadow: {
													inset: false,
													x: '0',
													y: '0',
													blur: '10',
													spread: '0',
													color: 'rgba(0,0,0,0.3)',
												},
												imageOpacity: {
													desktop: {
														val: 100,
														unit: '%',
													},
												},
												imageFilterGrayscale: {
													desktop: {
														val: 0,
														unit: '%',
													},
												},
												imageFilterBrightness: {
													desktop: {
														val: 100,
														unit: '%',
													},
												},
												imageFilterContrast: {
													desktop: {
														val: 100,
														unit: '%',
													},
												},
												imageFilterSaturate: {
													desktop: {
														val: 100,
														unit: '%',
													},
												},
												imageFilterSepia: {
													desktop: {
														val: 0,
														unit: '%',
													},
												},
												imageFilterBlur: {
													desktop: {
														val: 0,
														unit: 'px',
													},
												},
											},
										],
									],
								],
							],
						],
					] }
				/>
			</div>
		</div>
	);
}
